import React from 'react';
import { Link } from 'react-router-dom';
import Pop from 'components/Popover/Pop';
import Text from 'components/Text/Text';
import style from './ItemsAsLinkList.module.scss';

interface IProps {
	items: { id: string; name: Nullable<string> }[];
	link: string;
}

export const ItemsAsLinkList: React.FC<IProps> = React.memo(({ items, link }) => {
	const ItemsContent = () => {
		return (
			<div className={style.container} data-test="ItemsContent">
				{items.map((el) => (
					<div className={style.item} key={el.id}>
						<Link
							className={style.link}
							key={el.id}
							target={`blank_${Date.now()}`}
							rel="noopener noreferrer"
							to={`${link}${el.id}`}>
							<Text className={style.name} translationKey={el.name} size="xs" withTooltip={true} />
						</Link>
					</div>
				))}
			</div>
		);
	};

	return (
		<div data-test="ItemsAsLinkList">
			{items.length === 1 && (
				<Link
					className={style.link}
					target={`blank_${Date.now()}`}
					rel="noopener noreferrer"
					to={`${link}${items[0].id}`}>
					<Text className={style.name} translationKey={items[0].name} withTooltip={true} />
				</Link>
			)}
			{items.length > 1 && (
				<Pop placement="bottomLeft" content={<ItemsContent />} trigger="click">
					<div className={style.wrapper}>
						<Text translationKey={String(items.length)} data-test="numberOfItems" />
					</div>
				</Pop>
			)}
			{!items.length && <Text translationKey="-" />}
		</div>
	);
});
